import { jsx as m } from "react/jsx-runtime";
import "@fontsource/merriweather/300.css";
import "@fontsource/merriweather/400.css";
import "@fontsource/merriweather/700.css";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/open-sans/800.css";
import { ChakraProvider as i } from "@chakra-ui/react";
const P = ({
  children: r,
  theme: o
}) => /* @__PURE__ */ m(i, { theme: o, children: r });
export {
  P as ThemeProvider
};
